module.exports = __webpack_public_path__ + "img/71.1401f242.png";